import { createSelector } from 'reselect';

const getAgreementTypes = state => state.shared.agreementTypes;
const getInsuranceTypes = state => state.shared.propertyInsurances;
const getPropertyTypes = state => state.shared.propertyTypes;
const getStations = state => state.stations.list.stations;
const getPropertyStatuses = state => state.shared.propertyStatuses;
const getPropertyPromotionTypes = state => state.shared.propertyPromotionTypes;
const getContactObjects = state => state.contacts.list.contacts;
const getDefaultTexts = state => state.defaulttext.defaultTexts;

export const getAgreementTypeOptionList = createSelector(
    [getAgreementTypes],
    agreementTypes => {
        return agreementTypes
            ? Object.keys(agreementTypes).map(propertyAgreementTypeId => {
                  return {
                      id: propertyAgreementTypeId,
                      label: `${agreementTypes[propertyAgreementTypeId]
                          .propertyAgreementTypeName}`,
                  };
              })
            : [];
    }
);

export const getInsuranceTypeOptionList = createSelector(
    [getInsuranceTypes],
    propertyInsurances => {
        return propertyInsurances
            ? Object.keys(propertyInsurances).map(propertyInsuranceId => {
                  return {
                      id: propertyInsuranceId,
                      label:
                          propertyInsurances[propertyInsuranceId]
                              .propertyInsuranceName,
                      description:
                          propertyInsurances[propertyInsuranceId]
                              .propertyInsuranceDescription,
                  };
              })
            : [];
    }
);

export const getPropertyTypeOptionList = createSelector(
    [getPropertyTypes],
    propertyTypes => {
        return propertyTypes
            ? Object.keys(propertyTypes)
                  .sort((a, b) => {
                      return propertyTypes[a].propertyTypeOrder >
                      propertyTypes[b].propertyTypeOrder
                          ? -1
                          : 1;
                  })
                  .map(propertyTypeId => {
                      return {
                          id: propertyTypeId,
                          label: `${propertyTypes[propertyTypeId]
                              .propertyTypeName}`,
                      };
                  })
            : [];
    }
);

export const getStationOptionList = createSelector([getStations], stations => {
    return stations
        ? Object.keys(stations).map(stationId => {
              const stationName = stations[stationId].stationName;

              return {
                  id: stationId,
                  label: stations[stationId].stationCode
                      ? `${stations[stationId].stationCode} - ${stationName}`
                      : stationName,
              };
          })
        : [];
});

export const getPropertyStatusOptionList = createSelector(
    [getPropertyStatuses],
    statuses => {
        return statuses
            ? Object.keys(statuses).map(status => {
                  return {
                      id: status,
                      label: statuses[status],
                  };
              })
            : [];
    }
);

export const getPropertyPromotionTypesOptionList = createSelector(
    [getPropertyPromotionTypes],
    promoTypes => {
        return promoTypes
            ? Object.keys(promoTypes).map(promoType => {
                  return {
                      id: promoType,
                      label: promoTypes[promoType],
                  };
              })
            : [];
    }
);

export const getContacts = createSelector([getContactObjects], contacts => {
    return contacts
        ? Object.keys(contacts).map(contactId => {
              return Object.assign({}, contacts[contactId], {
                  fullName: `${contacts[contactId].contactForenames} ${contacts[
                      contactId
                  ].contactSurname}`,
              });
          })
        : [];
});

export const getDefaultTextsByFieldName = createSelector(
    [getDefaultTexts],
    defaultTexts => {
        return defaultTexts
            ? Object.keys(defaultTexts).reduce((result, defaultTextItemId) => {
                  const defaultTextItem = defaultTexts[defaultTextItemId];

                  result[defaultTextItem.defaultTextField.replace('@', '')] =
                      defaultTextItem.defaultTextContent;

                  return result;
              }, {})
            : {};
    }
);



// WEBPACK FOOTER //
// ./src/selectors/shared.js